angular
    .module('cabinetApp')
    .controller('paymentsCTRL', function paymentsCTRL($scope, $rootScope, paymentsModel, utilities) {
        $scope['payments']     = {};
        $scope['params']       = {};
        $scope['params']['payments']     = {};
        $scope['params']['transactions'] = {};

        // Загрузка транзакций transactions
        $scope.getTransactions = function() {
            $scope['params']['transactions']['status:eq']      = 'paid';
            $scope['params']['transactions']['account._id:eq'] = $rootScope['userId'];

            utilities.loader(true);
            return paymentsModel.getTransactions($scope['params']['transactions'], function(response) {
                utilities.loader();

                $scope['payments']['transactions'] = response;

                $scope['payments']['transactions'].forEach(function(item) {
                    item['valueFormatted'] = utilities.formatNumber(item['value'], 2, ' ');
                });
            });
        };

        // Загрузка оплат
        $scope.getPaymentList = function(data, noCash) {
            if (data) {
                $scope['params']['payments']['month_from'] = data['from'];
                $scope['params']['payments']['month_till'] = data['till'];
                $scope['params']['payments']['sectors']    = data['sectors'];
            } else {
                $scope['params']['payments']['month_from'] = utilities.getStartDayIso(new Date(utilities.getDate('12')));
                $scope['params']['payments']['month_till'] = utilities.getStartDayIso(utilities.getTodayDate());
                $scope['params']['payments']['sectors']    = $rootScope['dictionaries']['sectors'];
            }

            utilities.loader(true);
            return paymentsModel.getPaymentList($scope['params']['payments'], function(response) {
                utilities.loader();

                $scope['payments']['list'] = response['payments'];

                $scope['payments']['list'].forEach(function(item) {
                    item['valueFormatted'] = utilities.formatNumber(item['value'], 2, ' ');
                    item['sector']         = utilities.getValueFromDictionary($rootScope['dictionaries']['AccrualsSectorType'], 'value', item['sector_code'], 'text');
                });

                if (! noCash) {
                    utilities.saveData($scope['payments']['list'],   'paymentsData');
                    utilities.saveData($scope['params']['payments'], 'paymentsDataParams');
                }
            });
        };

        // Принудительная загрузка данных
        $scope.reloadData = function() {
            utilities.removeLocalData('paymentsData');
            utilities.removeLocalData('paymentsDataParams');

            $scope['payments']['list']         = [];
            $scope['payments']['transactions'] = [];

            $scope.getPaymentList()
                .then($scope.getTransactions);
        };

        // Объявление переменных и запуск функций
        $scope.paymentsPageStart = function() {
            var paymentsData    = utilities.loadData('paymentsData');
            var paymentsParams  = utilities.loadData('paymentsDataParams');
            var requestParams   = $scope['params']['payments'].toString();

            if (paymentsData !== null && paymentsParams.toString() === requestParams) {
                $scope['payments']['list'] = paymentsData;

                $scope.getTransactions();
            } else {
                $scope.getPaymentList()
                    .then($scope.getTransactions);
            }
        };

        // Применение фильтра
        $rootScope.$on('paymentsUpdateData', function(event, data) {
            $scope.getPaymentList(data, true);
        });

        // Отслеживание получения пользовательской ифнормации
        $rootScope.$watch('user.info.accounts', function(data) {
            if (! $.isEmptyObject(data)) {
                $scope.paymentsPageStart();
            }
        });

        // Формирование URL для скачки чека
        $scope.getReceipt = function(payment_id) {
            var href = '/api/v4/cash/online/receipt/' + payment_id + '/';
            return href
        };

    });
